import { render, staticRenderFns } from "./Portinerie.vue?vue&type=template&id=cd424c38&"
import script from "./Portinerie.vue?vue&type=script&lang=ts&"
export * from "./Portinerie.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports